<template>
  <div class="details-component">
    <div class="details-component__header">
      <h1>{{ $t('conferencereport.title') }}</h1>
    </div>
    <div class="details-component__content content">
      <form class="form fixed-form">
        <table class="details-table tenant no-col-padding edit-table fixed-table label-col-wide-260">
          <tr class="details-table__row" :class="{'details-table__row_error' : errors.has('year')}">
            <td class="details-table__col details-table__col_label">
              <label for="month" class="form__label">{{ $t('conferencereport.month') }}</label>
            </td>
            <td class="details-table__col" colspan="2">
              <el-date-picker
                v-model="selectedMonth"
                type="month"
                placeholder="Pick a month"
                value-format="M.yyyy"
                @change="monthChanged">
              </el-date-picker>
            </td>
          </tr>
          <tr class="details-table__row" :class="{'details-table__row_error' : errors.has('year')}">
            <td class="details-table__col details-table__col_label">
              <label for="year" class="form__label">{{ $t('conferencereport.conference_product') }}</label>
            </td>
            <td class="details-table__col" colspan="2">
              <el-select name="product"
                         v-model="selectedProduct"
                         v-validate="'required'"
                         v-if="products.length > 0">
                <el-option
                  v-for="product in products"
                  :key="product.id"
                  :label="product.name"
                  :value="product.id">
                </el-option>
              </el-select>
              <span class="load-error" v-else-if="loadError">{{ $t('conferencereport.failed_loading_conferences') }}</span>
              <span v-else>{{ $t('conferencereport.no_conferences') }}</span>
            </td>
          </tr>
        </table>
        <div class="form__buttons buttonset">
          <button type="submit" class="buttonset__button btn btn--main" v-show="selectedProduct" v-on:click.prevent.stop="onSubmit()">
            {{ $t('conferencereport.show_report') }}
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import moment from 'moment';

export default {
  props: ['product'],
  computed: {
    ...mapGetters({
      products: 'products/products/products',
    }),
  },
  route: {
    canReuse: true,
  },
  mounted() {
    this.selectCurrentMonth();
    this.fetchProducts();
  },
  methods: {
    fetchProducts() {
      this.selectedProduct = null;
      this.loadError = false;
      this.$store.dispatch('products/products/fetchConferencesByMonth', { user: this.user, month: this.selectedMonth }).catch(() => {
        this.loadError = true;
      });
    },
    selectCurrentMonth() {
      this.selectedMonth = moment().format('M.YYYY');
    },
    monthChanged() {
      this.fetchProducts();
    },
    onSubmit() {
      this.$router.push({ name: 'report-conference-product', params: { id: this.selectedProduct } });
    },
  },
  data() {
    return {
      selectedMonth: null,
      selectedProduct: null,
      loadError: false,
    };
  },
};
</script>
<style lang="scss" scoped>
@import '~styles/variables.scss';
@import '~styles/_mixins.scss';

.load-error {
    color: var(--brand-red);
}
</style>



// WEBPACK FOOTER //
// src/components/products/ConferenceReportsForm.vue